module.exports = __webpack_public_path__ + "static/img/top_pic@2x.1657271.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/top_pic@2x.png
// module id = i1B+
// module chunks = 1